import Model from '../utils/Model'

class OverseaAgentGrade {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'OverseaAgentGrade'

export const LEVEL1_AGENT = new OverseaAgentGrade(0, 'levelOne', '主代理')
export const LEVEL2_AGENT = new OverseaAgentGrade(1, 'levelTwo', '二级代理')

export const OVERSEAAGENTGRADES = [LEVEL1_AGENT, LEVEL2_AGENT]

/**
 *  return null:没找到.
 */
export function getOverseaAgentGradeByCode(code) {
  return Model.getObjByCode(code, OVERSEAAGENTGRADES)
}
